<template>
  <div class="col-4">
    <div class="trend-block" :class="{'down': direction === 'down'}">
      <div class="trend-block-inner">

        <div class="trend-period-head">
          {{ scale.name }}
        </div>

        <div class="row">
          <div class="col-8 trend-relative">
            {{ signedValue(relative) }}%
          </div>
          <div class="col-4 float-right trend-direction">
            <font-awesome-icon icon="long-arrow-alt-up" />
          </div>
        </div>

        <div class="trend-absolute">
          {{ signedValue(absolute) }} öre/kWh
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters} from 'vuex'

  export default {
    name: "TrendBlock",
    props: {
      scale: {
        required: true,
        format: Object
      },
      type: {
        required: true,
        format: String
      }
    },
    computed: {
      ...mapGetters('statistics', [
        'getTrendForScale'
      ]),
      trend() {
        return this.getTrendForScale(this.type, this.scale.handle) || {}
      },
      direction(){
        return this.absolute >= 0 ? 'up' : 'down'
      },
      absolute() {
        return this.trend.absolute
      },
      relative() {
        return this.trend.relative
      }
    },
    methods: {
      signedValue(value) {
        const sign = this.direction === 'up' ? '+' : '-'

        let abs = Math.abs(value)
        if(abs === 0){
          abs = `~1`
        }

        return `${sign}${abs}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Market/Prices/Trend/Block.vue